import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import validator from 'validator';
import {Button, ControlLabel, Form, FormControl, FormGroup, Glyphicon, HelpBlock, Panel, Table} from 'react-bootstrap';
import GreenLeafApi from '../utils/GreenLeafApi';
import ErrorComponent from '../ErrorComponent';
import './GenerateGroupAssessment.css';
import {toast, ToastContainer} from 'react-toastify';
import AssessmentSelector from './AssessmentSelector';

class GenerateGroupAssessment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      emails: [],
      email: '',
      errors: null,
      validation: {},
      subsection_ids: [],
      assessment: null,
    };
  }

  async componentDidMount() {
    if (this.props.location.state.subsection_ids) {
      this.props.location.state.subsection_ids.forEach((id) => {
        this.setState((state) => {
          state.subsection_ids.push(id);
          return state;
        });
      });
    } else {
      this.setState({subsection_ids: []});
    }

    try {
      const res = await GreenLeafApi.Assessment.find({ assessment_id: 1 });
      this.setState({ assessment: res.data[0] });
    } catch (e) {
      this.setState({ errors: e.errors });
    }

    this.setState({ isLoading: false });
  };

  emailValidate = (email) => {
    const valid = validator.isEmail(email);
    if (!valid) {
      this.setState({validation: {email: 'Invalid email address.'}});
    } else {
      this.setState({ validation: {} });
    }

    return valid;
  };

  submitGroupAssessment = async () => {
    if (this.state.emails.length > 0) {
      try {
        await GreenLeafApi.GroupTeamAssessment
          .create(this.props.match.params.teamId,
            this.state.assessment.id,
            this.state.emails,
            this.state.subsection_ids.length > 0 ? this.state.subsection_ids : this.state.assessment.subsections.map(s => s.id));

        toast.success('Survey successfully emailed!', {
          position: 'top-center',
          hideProgressBar: true,
          pauseOnHover: false,
          closeButton: false
        });
        this.setState({emails: [], errors: null});
      } catch (e) {
        this.setState({ errors: e.errors });
      }
    } else {
      this.setState({ errors: [{ msg: 'Must add at least one email.' }] });
    }
  };

  selectAssessment = (assessment) => {
    this.setState({assessment});
  };

  removeEmailFromList = async (index) => {
      this.setState({ emails: this.state.emails.filter((_, i) => i !== index) });
  };

  onFormSubmit = (event) => {
    event.preventDefault();

    if (this.emailValidate(this.state.email)) {
      this.setState(prevState => {
        prevState.email = '';
        prevState.emails.push(this.state.email);
        return prevState;
      });
    }
  };

  render() {
    if (this.state.isLoading) return <p>Loading...</p>;

    return (
      <div className='SendInvites'>
        <h2 className='mb3 ta-center'>Create Team Self Assessment</h2>
        <div className='m-auto' style={{width: '90%'}}>
          <p>
            Choose an assessment for the team to complete and enter their emails below.
            <br/><br/>
            Team members will receive a link to the assessment in an email.
            <br/><br/>
            Automatic reminder emails will be sent to unfinished members once a day.
            <br/><br/>
            To manually resend a link to a team member, click the &nbsp;<Glyphicon glyph={'info-sign'}/>&nbsp; next to the unfinished assessment on the team page.
          </p>
          <br/>
        </div>

        <ErrorComponent error={this.state.errors}/>

        <div style={{ width: '90%', margin: '0 auto 50px auto' }}>
          <Form onSubmit={this.onFormSubmit}>
            <FormGroup>
              <ControlLabel>Assessment: </ControlLabel>
              <AssessmentSelector
                assessment={this.state.assessment}
                onSelect={this.selectAssessment}
              />
            </FormGroup>
            <div style={{ display: 'flex', flexDirection: 'row', margin: '50px auto 0 auto' }}>
              <FormGroup className='full-width' validationState={this.state.validation && this.state.validation.email ? 'error' : null} controlId="formHorizontalEmail">
                <FormControl name="email" type="text" value={this.state.email} placeholder="Email" onChange={(event) => this.setState({ email: event.target.value })}/>
                <FormControl.Feedback/>
                {this.state.validation.email ? <HelpBlock>{this.state.validation.email}</HelpBlock> : ''}
              </FormGroup>
              <Button data-cy='add-email' type='submit' style={{height: '50%', width: '20%'}}>Add</Button>
            </div>
          </Form>

          <Panel className='mt0'>
            <Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
              {
                this.state.emails.map((email, i) => {
                  return (
                    <tr key={i+1}>
                      <td>{i+1}</td>
                        <td>{email} <Glyphicon className={['pull-right', 'clickable']} glyph='remove' onClick={() => this.removeEmailFromList(i)}/></td>
                    </tr>
                  );
                })
              }
              </tbody>
            </Table>
          </Panel>
          <div className='flex-row-spaced'>
            <Button
              data-cy='done'
              className='mr1'
              onClick={() => this.props.history.push(`/companies/${this.props.match.params.companyId}/programs/${this.props.match.params.programId}/teams/${this.props.match.params.teamId}`)}
            >
              Return to Team Page
            </Button>
            <Button data-cy='send-invites' className='primary' onClick={this.submitGroupAssessment}>Send Invites</Button>
          </div>
        </div>

        <ToastContainer
          position="top-center"
          closeOnClick={false}
          autoClose={3000}
          hideProgressBar
          newestOnTop
          rtl={false}
          pauseOnVisibilityChange={false}
          draggablePercent={80}
          pauseOnHover={false}
        />
      </div>
    );
  }
}

export default withRouter(GenerateGroupAssessment);



// WEBPACK FOOTER //
// ./src/components/teams/GenerateGroupAssessment.js